import { fullscreenElementSupport } from '@polestar/component-warehouse-react/helpers/fullscreen';
import { isBrowser } from '@polestar/component-warehouse-react/helpers/supports';
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.platform)
    ? true
    : navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
/*
 * This check is using the `navigator`, because:
 *
 * iOS does not support other elements than <video> to go fullscreen.
 * iPadOS does support elements to go fullscreen like Maps, but not when a <video> is inside that element
 *
 * so `fullscreenElementSupport` will not provide enough information to know if fullscreen for a playerRef is supported.
 *
 * Note: the strange thing is that Android supports elements to go fullscreen (with a video inside), but just shows it (which is probably needed while the Polestar HMI is in portrait mode).
 * Still the default behaviour on Android is to let the video go fullscreen and go in portrait mode to landscape video. Due to the Polestar HMI this cannot be using the default behaviour
 * and is therefore not implemented in the check.
 */
export const fullscreenVideoElementSupport = isBrowser &&
    (fullscreenElementSupport || !!document.createElement('video').webkitRequestFullscreen) &&
    !isIOS();
/** NOT USED DUE TO CHROME BUG MENTIONED BELOW */
// export function textTracksVerticalPosition(cues: TextTrackCueList): void {
//   if (cues !== null && cues.length > 0) {
//     for (const c of cues) {
//       const cue = c as VTTCue;
//       if (cue.line === 'auto' || cue.line === -1) {
//         // vertical alignment in % of height from the top
//         cue.line = 80;
//         // cue.snapToLines = false;
//       }
//     }
//   }
// }
export const getAvailableSubtitles = (subtitles) => {
    const subtitleList = [];
    if (subtitles) {
        let i = 0;
        for (const subtitle of subtitles) {
            subtitleList.push({
                label: subtitle.label,
                language: subtitle.language,
                mode: subtitle.mode,
                index: i,
            });
            /**
             * THIS DOES NOT WORK DUE TO A CHROME BUG
             * see https://bugs.chromium.org/p/chromium/issues/detail?id=1141592&q=snapToLines&can=2 for more information
             */
            // Force the position of the subtitle track on 85%
            // We don't have a "loaded" event, so have to wait on timeout (fallback) or the first visual cuechange
            // const setPosition = () => {
            //   subtitle.cues && textTracksVerticalPosition(subtitle.cues);
            //   subtitle.removeEventListener('cuechange', setPosition);
            // };
            // subtitle.addEventListener('cuechange', setPosition);
            // setTimeout(() => {
            //   subtitle.cues && textTracksVerticalPosition(subtitle.cues);
            // }, 1000);
            i++;
        }
    }
    return subtitleList;
};
export const setSelectSubtitle = (subtitles, index) => {
    if (subtitles) {
        let i = 0;
        for (const subtitle of subtitles) {
            subtitle.mode = i === index && subtitle.language !== '' ? 'showing' : 'disabled';
            i++;
        }
    }
};
export const getSelectSubtitleIndex = (subtitles) => {
    if (subtitles) {
        let i = 0;
        for (const subtitle of subtitles) {
            if (subtitle.mode === 'showing') {
                return i;
            }
            i++;
        }
    }
    return -1;
};
// For use with the iOS LPM override hack
export const isSafariBrowser = () => {
    let userAgent = '';
    let isIOS = false;
    let isSafari = false;
    let isMobileSafari = false;
    let isDesktopSafari = false;
    if (isBrowser) {
        userAgent = window.navigator.userAgent;
        isIOS = userAgent.includes('iPhone OS');
        // Chrome 106 includes Safari in the user agent string
        isSafari = userAgent.includes('Safari') && !userAgent.includes('Chrome');
        isMobileSafari = userAgent.includes('Mobile') && userAgent.includes('Safari');
        // Possibly desktop Safari, but could be iOS/iPadOS in 'Request Desktop Website' mode
        isDesktopSafari = userAgent.includes('Mac OS X') && userAgent.includes('Safari');
    }
    return { isIOS, isSafari, isMobileSafari, isDesktopSafari, userAgent };
};
